import React, { useEffect, useState } from "react";
import { useLang } from "../context/LanguageContext";
import { PageHead } from "./Shop";
import { MapPin, FileText } from "lucide-react";
import { api, mediaUrl } from "../api";
import useSeo from "../hooks/useSeo";

const Projects = () => {
  const { tr, ui } = useLang();
  const [projects, setProjects] = useState([]);
  useSeo({
    title: ui.nav.projects,
    description: { en: "Selected HAAS Mosaic projects around the world — hotels, villas, pools and public spaces adorned with handcrafted marble mosaics.", tr: "Dünyanın dört bir yanından seçilmiş HAAS Mosaic projeleri — el yapımı mermer mozaiklerle donatılmış oteller, villalar, havuzlar ve kamusal alanlar." },
  });

  useEffect(() => {
    api.projects().then(setProjects).catch(() => setProjects([]));
  }, []);

  return (
    <div className="bg-[#f7f3ee]">
      <PageHead title={ui.allProjects} subtitle={ui.projectsIntro} image="/mosaic/2025/08/all-project.jpeg" />
      <section className="py-16 md:py-24">
        <div className="max-w-[1360px] mx-auto px-5 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
            {projects.map((p, i) => {
              const wide = i % 3 === 0;
              const hasPdf = !!p.pdf;
              const Wrapper = hasPdf ? "a" : "div";
              const wrapProps = hasPdf ? { href: mediaUrl(p.pdf), target: "_blank", rel: "noopener noreferrer" } : {};
              return (
                <Wrapper key={p.id} {...wrapProps} className={`card-img-zoom group relative block overflow-hidden ${wide ? "md:col-span-2 h-[460px]" : "h-[400px]"} ${hasPdf ? "cursor-pointer" : ""}`}>
                  <img src={mediaUrl(p.image)} alt={tr(p.name)} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                  {hasPdf && (
                    <span className="absolute top-5 right-5 inline-flex items-center gap-2 bg-[#f7f3ee]/95 text-[#211d18] text-[11px] uppercase tracking-[0.14em] px-4 py-2 opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0 transition-all duration-300">
                      <FileText size={14} className="text-[#a67c52]" /> {tr({ en: "View Catalogue", tr: "Kataloğu Gör" })}
                    </span>
                  )}
                  <div className="absolute bottom-0 p-8">
                    <p className="flex items-center gap-2 text-[#e2c9a8] text-[11px] uppercase tracking-[0.2em] mb-2"><MapPin size={13} /> {tr(p.location)}</p>
                    <h3 className="text-white font-serif text-3xl">{tr(p.name)}</h3>
                  </div>
                </Wrapper>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;
